import React from 'react';
import { useLocation } from 'react-router-dom';
import { Footer, SectionHeader } from '../../components'
import MainLayout from '../../layouts/main-layout/main-layout';

const Redirect = () => {
  const location = useLocation();

  let mobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    any: function () {
      return (mobile.Android() || mobile.iOS());
    }
  };

  let client = mobile.any();  
  if (String(client) === 'Android') {
    const url ="intent://gohome/#Intent;scheme=claropay;package=com.globalhitss.claro.pay;end";
    window.location.replace(url);
  } else if (String(client) === 'iPhone' || String(client) === 'iPad' || String(client) === 'iPod') {
    window.location.replace("claropay://");
    setTimeout(() => {
      window.location.replace("https://apps.apple.com/mx/app/claro-pay/id1502765283");
    }, 3000);
  } else {
    window.location.href = 'https://mx.claropay.com/' + location.search;  
  }

  return (
    <>
      <MainLayout />
      <SectionHeader/>
      <Footer />
    </>
  );
}

export default Redirect;
